// TOP SALES page: gallery ⇄ list toggle, persisted per browser.
import { t } from "../client/i18n.js";
const gallery = document.getElementById("ts-gallery");
const table = document.getElementById("ts-table");
const toggle = document.getElementById("ts-toggle");

const apply = (view: string) => {
  if (gallery) gallery.hidden = view === "list";
  if (table) table.hidden = view !== "list";
  if (toggle) toggle.textContent = t(view === "list" ? "client.topsales.gallery_view" : "client.topsales.list_view");
};

let view = localStorage.getItem("mdx-topsales-view") === "list" ? "list" : "gallery";
apply(view);

toggle?.addEventListener("click", () => {
  view = view === "list" ? "gallery" : "list";
  localStorage.setItem("mdx-topsales-view", view);
  apply(view);
});
